import React from 'react';
import { BetWrightMainLogo, BetWrightMainLogoWrapper } from 'src/domains/common/universes/betwright/betwright.style';

export const BetWrightLogotype = (): JSX.Element => (
    <BetWrightMainLogoWrapper>
        <BetWrightMainLogo />
    </BetWrightMainLogoWrapper>
);
